import styled from 'styled-components';

export const Container = styled.div`
  height: 80vh;
  max-height: 80vh;
`;

export const ContainerChat = styled.div`
  height: 92%;
  max-height: 92%;

  border-radius: 8px;
  border: 1px solid #f1f1f1;
`;
